import { request } from "http";

const BACKEND_API = (window as any).injectedEnv?.WE_ENV_BACKEND_API || `${window.location.origin}`;

const KEYCLOAK_URL = (window as any).injectedEnv?.WE_ENV_KEYCLOAK_URL || `${window.location.origin}`;

const WEBSOCKET_URL = (window as any).injectedEnv?.WE_ENV_WEBSOCKET_URL || "wss://web.ved-box-dev.web3tech.ru";

const CLOUD_URL = (window as any).injectedEnv?.WE_ENV_CLOUD_URL || "https://storage.yandexcloud.net";

export const getKeyCloakUrl = () => `${KEYCLOAK_URL}/api/v0/ved-auth-provider`;
const getBaseApiUrl = () => `${BACKEND_API}/api/v0/ved-web`;
const getWebSocketUrl = () => `${WEBSOCKET_URL}/api/v0/ved-web-ws`;
const getCloudUrl = () => `${CLOUD_URL}/web3tech-ved-dev`;

export const ENDPOINTS = {
  // keycloak-auth
  loginOtp: () => `${getKeyCloakUrl()}/login/otp`,
  token: () => `${getKeyCloakUrl()}/oauth2/token`,
  changePassword: () => `${getKeyCloakUrl()}/password/change`,
  userInfo: () => `${getKeyCloakUrl()}/userinfo`,

  // VED
  contracts: () => `${getBaseApiUrl()}/contract`,
  contractById: (id: string) => `${getBaseApiUrl()}/contract/${id}`,
  uploadContractFile: (id: string) => `${getBaseApiUrl()}/contract/${id}/attach-doc`,
  returnContractToDraft: (id: string) => `${getBaseApiUrl()}/contract/${id}/draft`,
  declineContractDraft: (id: string) => `${getBaseApiUrl()}/contract/${id}/decline-draft`,
  returnContractToDraftForCustomer: (id: string) => `${getBaseApiUrl()}/contract/${id}/return-to-draft`,
  blockContract: (id: string) => `${getBaseApiUrl()}/contract/${id}/block`,
  unblockContract: (id: string) => `${getBaseApiUrl()}/contract/${id}/unblock`,
  removeContractFile: (contractId: string, docId: string) =>
    `${getBaseApiUrl()}/contract/${contractId}/delete-doc/${docId}`,
  approveContractById: (id: string) => `${getBaseApiUrl()}/contract/${id}/approve`,
  updateContractById: (id: string) => `${getBaseApiUrl()}/contract/${id}/update`,
  contractAvailableLimit: (id: string) => `${getBaseApiUrl()}/contract/${id}/available_limit`,
  contractHistory: (id: string) => `${getBaseApiUrl()}/contract/${id}/history`,
  getBankByUnk: () => `${getBaseApiUrl()}/contract/unk-check`,
  generateOperation: (type: string) => `${getBaseApiUrl()}/otp/generate/${type}`,
  countryList: () => `${getBaseApiUrl()}/country`,
  fiatCurrencyList: () => `${getBaseApiUrl()}/info/fiat-currency`,
  contractBidsReport: (contractId: string) => `${getBaseApiUrl()}/report/${contractId}/requests-by-contract`,

  pendingStatistics: () => `${getBaseApiUrl()}/request/pending-actions/statistics`,
  pendingActionsBids: () => `${getBaseApiUrl()}/request/pending-actions`,
  bids: () => `${getBaseApiUrl()}/request`,
  companyContracts: (id: string) => `${getBaseApiUrl()}/contract/company/${id}`,
  companyUsers: (id: string) => `${getBaseApiUrl()}/user/company/${id}`,
  contractBids: (unk: string) => `${getBaseApiUrl()}/request-by-contract/${unk}`,
  bidById: (id: string) => `${getBaseApiUrl()}/request/${id}`,
  bidHistory: (id: string) => `${getBaseApiUrl()}/request/${id}/history`,
  declineDraftBid: (id: string) => `${getBaseApiUrl()}/request/${id}/decline-draft`,
  returnBidToDraft: (id: string) => `${getBaseApiUrl()}/request/${id}/return-to-draft`,
  cancelBid: (id: string) => `${getBaseApiUrl()}/request/${id}/cancel`,
  bidReportFile: (id: string) => `${getBaseApiUrl()}/request/${id}/report`,
  uploadBidFile: (bidId: string) => `${getBaseApiUrl()}/request/${bidId}/attach-doc`,
  removeBidFile: (params: { requestId: string; documentId: string }) =>
    `${getBaseApiUrl()}/request/${params.requestId}/delete-doc/${params.documentId}`,
  bidTransactions: (id: string) => `${getBaseApiUrl()}/request-tx/${id}`,
  bidWalletChecks: (id: string) => `${getBaseApiUrl()}/request/${id}/wallet-check`,
  editCompanyFeeForBid: (id: string) => `${getBaseApiUrl()}/request/${id}/update-fee`,
  passAmlCheck: (id: string) => `${getBaseApiUrl()}/request/${id}/aml-pass`,
  stopDeal: (id: string) => `${getBaseApiUrl()}/request/${id}/aml-hold`,
  approveTransaction: (hash: string) => `${getBaseApiUrl()}/request-tx/approve/${hash}`,
  approveWalletCheck: (hash: string) => `${getBaseApiUrl()}/request-wallet-check-approve/${hash}`,
  refundCurrency: (id: string) => `${getBaseApiUrl()}/request/${id}/refund`,
  executeBid: (id: string) => `${getBaseApiUrl()}/request/${id}/execute`,
  stepBack: (id: string) => `${getBaseApiUrl()}/request/${id}/step-back`,
  acceptBidConditions: (id: string) => `${getBaseApiUrl()}/request/${id}/agent-proposal-accept`,
  approveBid: (id: string) => `${getBaseApiUrl()}/request/${id}/approve`,
  agentProposal: (id: string) => `${getBaseApiUrl()}/request/${id}/agent-proposal`,
  bidBankAccount: (id: string) => `${getBaseApiUrl()}/request/${id}/bank-account`,
  getBidBalance: (id: string) => `${getBaseApiUrl()}/request/${id}/balance`,
  getRefundWallets: (id: string) => `${getBaseApiUrl()}/request/${id}/refund-wallets`,
  bankStatement: (id: string) => `${getBaseApiUrl()}/request/${id}/account-details`,
  getRefundNative: (id: string) => `${getBaseApiUrl()}/request/${id}/refund-native`,
  getCollectQuote: (id: string) => `${getBaseApiUrl()}/request/${id}/collect-quote`,

  // speedUpBidTransaction: (id: string) => `${getBaseApiUrl()}/wallets/bids/${id}/speedUp`,
  quotes: (id: string) => `${getBaseApiUrl()}/quote/${id}`,
  createQuote: () => `${getBaseApiUrl()}/quote`,
  quoteIdAccept: (id: string) => `${getBaseApiUrl()}/quote/${id}/accept`,

  bidOperation: (params: { id: string; operation: string }) =>
    `${getBaseApiUrl()}/request/${params.id}/${params.operation}`,
  approveQuote: (id: string) => `${getBaseApiUrl()}/quote/${id}/approve`,

  rulesFile: () => `${getBaseApiUrl()}/rules`,
  companyOfferFile: () => `${getBaseApiUrl()}/rules/offer`,
  downloadOfferTemplate: () => `${getBaseApiUrl()}/rules/offer/template`,
  generateReport: (reportType: string) => `${getBaseApiUrl()}/report/${reportType}`,
  requestReport: (companyId: string) => `${getBaseApiUrl()}/report/${companyId}/requests`,
  reportById: (id: string) => `${getBaseApiUrl()}/report/${id}`,
  deleteRuleDoc: (id: string) => `${getBaseApiUrl()}/rules/delete/${id}`,
  uploadRuleDoc: () => `${getBaseApiUrl()}/rules/upload`,

  companies: () => `${getBaseApiUrl()}/company`,
  userCompanies: (userId: string) => `${getBaseApiUrl()}/company/user/${userId}`,
  companyById: (id: string) => `${getBaseApiUrl()}/company/${id}`,
  editCompanyById: (id: string) => `${getBaseApiUrl()}/company/${id}/update`,
  providerWallets: (id: string) => `${getBaseApiUrl()}/company/${id}/wallets`,
  nativeCurrencyRate: (network: string) => `${getBaseApiUrl()}/rate/native/${network}`,
  defaultQuoteExpTime: () => `${getBaseApiUrl()}/company/default-quote-exp-time`,
  cancelQuote: (id: string) => `${getBaseApiUrl()}/quote/${id}/cancel`,
  uploadCompanyFile: (companyId: string) => `${getBaseApiUrl()}/company/${companyId}/attach-doc`,
  removeCompanyFile: (params: { id: string; documentId: string }) =>
    `${getBaseApiUrl()}/company/${params.id}/delete-doc/${params.documentId}`,
  blockCompany: (id: string) => `${getBaseApiUrl()}/company/${id}/block`,
  activateCompany: (id: string) => `${getBaseApiUrl()}/company/${id}/activate`,
  unblockCompany: (id: string) => `${getBaseApiUrl()}/company/${id}/unblock`,
  connectCompanyAndUser: (companyId: string, userId: string) =>
    `${getBaseApiUrl()}/company/${companyId}/add-user/${userId}`,
  removeUserFromCompany: (id: string, userId: string) => `${getBaseApiUrl()}/company/${id}/remove-user/${userId}`,
  createBeneficiary: (id: string) => `${getBaseApiUrl()}/company/${id}/beneficiary`,
  bankAccount: (companyId: string) => `${getBaseApiUrl()}/company/${companyId}/bank-account`,
  getBankAccountDetails: (companyId: string, accountId: string) =>
    `${getBaseApiUrl()}/company/${companyId}/bank-account/${accountId}`,
  setDefaultBankDetails: (id: string, accountId: string) =>
    `${getBaseApiUrl()}/company/${id}/default-bank-account/${accountId}`,
  deleteBankDetails: (id: string, accountId: string) =>
    `${getBaseApiUrl()}/company/${id}/bank-account/${accountId}/archive`,
  bankList: () => `${getBaseApiUrl()}/bank`,
  getCompanySettings: (id: string) => `${getBaseApiUrl()}/company/${id}/settings`,

  users: () => `${getBaseApiUrl()}/user`,
  userById: (id: string) => `${getBaseApiUrl()}/user/${id}`,
  updateUserById: (id: string) => `${getBaseApiUrl()}/user/${id}/update`,
  updateUserRoles: (userId: string) => `${getBaseApiUrl()}/user/${userId}/roles`,
  passwordReset: (id: string) => `${getBaseApiUrl()}/user/${id}/psw-reset`,
  blockUser: (id: string) => `${getBaseApiUrl()}/user/${id}/block`,
  unblockUser: (id: string) => `${getBaseApiUrl()}/user/${id}/unblock`,

  notificationSettings: (userId: string, companyId: string) =>
    `${getBaseApiUrl()}/user/${userId}/${companyId}/notification-settings`,

  doubleActionsSettings: (companyId: string) => `${getBaseApiUrl()}/company/${companyId}/settings`,

  userWalletCheck: () => `${getBaseApiUrl()}/user-wallet-check`,
  remainingDailyLimit: () => `${getBaseApiUrl()}/user-wallet-check/limit`,
  userWalletCheckById: (id: string) => `${getBaseApiUrl()}/user-wallet-check/${id}`,
  getIdForWalletCheck: () => `${getBaseApiUrl()}/kyt/wallet-check`,
  walletCheck: (id: string) => `${getBaseApiUrl()}/kyt/wallet-check/${id}`,
  walletCheckReport: (checkId: string) => `${getBaseApiUrl()}/kyt/wallet-check/${checkId}/pdf-report`,
  manualCheckReport: (checkId: string) => `${getBaseApiUrl()}/kyt/transfer-check/${checkId}/pdf-report`,
  getWalletTokens: (id: string) => `${getBaseApiUrl()}/wallets/${id}/check-token`,
  refundCustomTokens: (id: string) => `${getBaseApiUrl()}/wallets/${id}/refund-token`,

  getCompanyFees: () => `${getBaseApiUrl()}/settings`,
  updateCompanyFees: () => `${getBaseApiUrl()}/settings/update`,
  settingsInfoText: () => `${getBaseApiUrl()}/settings/info-text`,
  settingsWebSettings: () => `${getBaseApiUrl()}/settings/web-settings`,
  logo: () => `${getBaseApiUrl()}/logo`,
  favicon: () => `${getBaseApiUrl()}/logo/favicon`,
  smsTemplate: () => `${getBaseApiUrl()}/settings/sms-template`,
  resetSmsTemplate: (type: string) => `${getBaseApiUrl()}/settings/sms-template/${type}/reset`,
  mailLayout: () => `${getBaseApiUrl()}/settings/mail-layout`,
  resetMailLayout: () => `${getBaseApiUrl()}/settings/mail-layout/reset`,

  globalBalances: () => `${getBaseApiUrl()}/global-balances`,

  getRates: () => `${getBaseApiUrl()}/rate`,
  getCryptoRates: () => `${getBaseApiUrl()}/crypto-rates`,
  updateRates: () => `${getBaseApiUrl()}/rate/update`,

  getCertificate: () => `${getBaseApiUrl()}/csp/issue-certificate`,

  uploadDoc: () => `${getBaseApiUrl()}/docs/upload`,
  fileFromCloud: (key: string) => `${getCloudUrl()}/${key}`,
  amlCheckStatus: (id: string) => `${getBaseApiUrl()}/aml-check-status/${id}`,

  webSocket: () => `${getWebSocketUrl()}/ws`,

  getAllTemplates: () => `${getBaseApiUrl()}/template`,
  getTemplateType: (type: string) => `${getBaseApiUrl()}/template/${type}`,
  uploadTemplateFile: (type: string) => `${getBaseApiUrl()}/template/${type}/upload`,
  downloadTemplateFile: (type: string) => `${getBaseApiUrl()}/template/${type}/download`,
  downloadDefaultTemplateFile: (type: string) => `${getBaseApiUrl()}/template/${type}/download/default`,

  amlApproveRiskAll: (requestId: string) => `${getBaseApiUrl()}/request-tx/approve-all/${requestId}`,

  getDmnTooltips: (bidId: string) => `${getBaseApiUrl()}/dmn/request/${bidId}/tooltips`,

  nominalAccounts: () => `${getBaseApiUrl()}/nominal-accounts`,
  nominalAccountOverallBalance: () => `${getBaseApiUrl()}/nominal-accounts/overall-balance`,
  nominalAccountBankAccountsForBeneficiary: (id: string) =>
    `${getBaseApiUrl()}/nominal-account/beneficiaries/details/${id}/bank-account`,

  rubWithdrawalRequest: () => `${getBaseApiUrl()}/rub-withdrawal-request`,
  startProcessingRubWithdrawalRequest: (bidId: string) =>
    `${getBaseApiUrl()}/rub-withdrawal-request/${bidId}/processing`,
  completeRubWithdrawalRequest: (bidId: string) => `${getBaseApiUrl()}/rub-withdrawal-request/${bidId}/complete`,
  cancelRubWithdrawalRequest: (bidId: string) => `${getBaseApiUrl()}/rub-withdrawal-request/${bidId}/cancel`,
  rubOperations: () => `${getBaseApiUrl()}/rub-operations`,

  requestNominalFundsWithdrawal: (id: string) => `${getBaseApiUrl()}/request/${id}/transfer`,
  requestCustomerExecuted: (id: string) => `${getBaseApiUrl()}/request/${id}/customer-executed`,
  rubOperationDeposit: () => `${getBaseApiUrl()}/rub-operations/deposit`,
  getPlatformDetails: () => `${getBaseApiUrl()}/platform-details`,

  getOfferDocCodes: () => `${getBaseApiUrl()}/rules/offer/fields`,
  uploadOfferTemplate: () => `${getBaseApiUrl()}/rules/offer/template`,

  retryTransaction: (id: string) => `${getBaseApiUrl()}/request/${id}/retry-execution`,
  extendQuote: (id: string) => `${getBaseApiUrl()}/quote/${id}/extend`,
  verifyWalletQuote: (id: string) => `${getBaseApiUrl()}/quote/${id}/verify-wallet`,
  getAllTooltips: () => `${getBaseApiUrl()}/dmn/tooltips`,
  downloadDefaultDocTooltips: (status: string) => `${getBaseApiUrl()}/dmn/request/status/${status}/tooltips/default`,
  downloadDocTooltipsRules: (status: string) => `${getBaseApiUrl()}/dmn/request/status/${status}/tooltips`,
  uploadTooltipsFile: (status: string) => `${getBaseApiUrl()}/dmn/request/status/${status}/tooltips`,
  getPlatformFeeStatistics: () => `${getBaseApiUrl()}/platform/fee-statistics`,
  updateCurrencyOperationCode: (id: string) => `${getBaseApiUrl()}/request/${id}/update-currency-operation-code`,

  walletsWhitelist: () => `${getBaseApiUrl()}/wallets-whitelist`,
  checkWalletWhitelist: () => `${getBaseApiUrl()}/wallets-whitelist/check`,
  updateWhitelist: (companyId: string) => `${getBaseApiUrl()}/company/${companyId}/whitelist/update`,
  forbidWalletWhitelist: ({ companyId, walletId }: { companyId: string; walletId: string }) =>
    `${getBaseApiUrl()}/company/${companyId}/wallets-whitelist/${walletId}/forbid`,
  allowWalletWhitelist: ({ companyId, walletId }: { companyId: string; walletId: string }) =>
    `${getBaseApiUrl()}/company/${companyId}/wallets-whitelist/${walletId}/allow`,
  requestFeeSettings: () => `${getBaseApiUrl()}/settings/request-fee-settings`,
};
